export class SubDivision {
    code: string = '';
    name: string  = '';
    sapSubDivision: string = '';
}

export interface ISubDivisions {
    _id: string;
    division: number;
    subDivision: Array<{code: string, name: string, sapSubDivision: string}>
}



// WEBPACK FOOTER //
// ./src/app/models/SubDivision.model.ts